// @ts-check

import * as _ from 'lodash-es'

/** @type {import('vue').ComponentOptionsMixin} */
export const attrsMixin = {
  inheritAttrs: false,
  computed: {
    classes() {
      return this.$attrs.class
    },
    styles() {
      return this.$attrs.style
    },
    attributes() {
      return _.omit(this.$attrs, ['class', 'style'])
    }
  }
}

export default attrsMixin
